import React from "react";
import {
    obtenerMotivoSinCierre,
    obtenerTextoIndicacion,
} from "../helpers/textosSiguienteCierre";

// Indicación debajo de los filtros de lo que le toca al producto padre elegido.
// Acompaña la elección de los filtros, así que se quita en cuanto la consulta
// muestra el periodo a cerrar. Si el producto padre no puede registrar cierres,
// al consultar el motivo pasa al espacio del error y aquí ya no se repite
export const IndicacionSiguienteCierre = ({ hook }) => {
    const {
        siguienteCierre,
        padreProductoTerminado,
        previsualizacion,
        mensajeError,
    } = hook;

    if (!siguienteCierre || !padreProductoTerminado || previsualizacion) {
        return null;
    }

    const nombrePadre = padreProductoTerminado.nombre;

    if (mensajeError && obtenerMotivoSinCierre(siguienteCierre, nombrePadre)) {
        return null;
    }

    return (
        <p className="comparativo-mensual__indicacion-filtros">
            {obtenerTextoIndicacion(siguienteCierre, nombrePadre)}
        </p>
    );
};
